module.exports = __webpack_public_path__ + "img/facebook-login.b2c48fbb.svg";